import { configureStore } from "@reduxjs/toolkit"
import LoadingReducer from "./features/LoadingSlice"
import tripReducer from "./features/tripSlice"

export default configureStore({
    reducer: {
        loader: LoadingReducer,
        trips: tripReducer,
    }
})